import {
  lazy,
  Suspense,
} from 'react';

const LoginMock = lazy(async () =>
  import.meta.env.DEV
    // eslint-disable-next-line import-x/dynamic-import-chunkname
    ? import('./LoginMock').then(module => ({ default: module.LoginMock }))
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    : Promise.resolve({ default: () => null }));

export const LoginMockLoader = () => {
  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <Suspense
      fallback={(
        <div>
          {'Loading...'}
        </div>
      )}
    >
      <LoginMock />
    </Suspense>
  );
};
